import { render, staticRenderFns } from "./MemberPeriodsRecord.vue?vue&type=template&id=2076722a&scoped=true"
import script from "./MemberPeriodsRecord.vue?vue&type=script&lang=js"
export * from "./MemberPeriodsRecord.vue?vue&type=script&lang=js"
import style0 from "./MemberPeriodsRecord.vue?vue&type=style&index=0&id=2076722a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2076722a",
  null
  
)

export default component.exports